import { createSpinner, createTdWithElement } from "../../DomUtilities/ElementsCreator";
import openErrorModal from "../../Error/ErrorModal";
import { fetchVariantsList } from "../../HTTPRequests/VariantRequests";
import Mediator from "../../Utilities/Mediator";
import CreateVariantModal from "./CreateVariantModal";
import UpdateVariantModal from "./UpdateVariantModal";

export default class Variants {
	serviceId: string;
	itemId: string;
	isAccordionOpen: boolean;
	variantsAccordion: HTMLTableRowElement;
	serviceRow: HTMLTableRowElement;
	tdContainer: HTMLTableCellElement;
	spinner: HTMLElement;

	constructor() {
		this.isAccordionOpen = false;
		this.variantsAccordion = document.createElement('tr');
		this.spinner = createSpinner();
		this.tdContainer = createTdWithElement(this.spinner);
		this.tdContainer.colSpan = 6;

		Mediator.off("variantCrudOperationFinished");
		Mediator.on("variantCrudOperationFinished", () => this.fetchList());
	}

	public init(tr: HTMLTableRowElement) {
		tr.onclick = () => {
			if (tr.id) {
				this.checkAccordion(tr);
			}
		}
	}

	private checkAccordion(row: HTMLTableRowElement) {
		if (this.isAccordionOpen) {
			if (this.serviceId === row.id) {
				this.closeAccordion();
			} else {
				this.closeAccordion();
				this.serviceRow = row;
				this.openAccordion();
			}
		} else {
			this.serviceRow = row;
			this.openAccordion();
		}
	}

	public fetchList() {
		this.tdContainer.innerHTML = "";
		this.tdContainer.appendChild(this.spinner);

		fetchVariantsList(this.serviceRow.id)
			.then((response: string) => {
				this.tdContainer.innerHTML = response;
				new CreateVariantModal(this.serviceId).addCreateModalClickListener();
				new UpdateVariantModal(this.itemId, this.serviceId).addUpdateModalsClickListeners();
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			});
	}

	private openAccordion() {
		this.serviceRow.classList.add("accordion-open");
		this.serviceId = this.serviceRow.id;
		this.itemId = this.serviceRow.dataset.itemId;
		this.isAccordionOpen = true;
		this.variantsAccordion.appendChild(this.tdContainer);
		this.serviceRow.insertAdjacentElement('afterend', this.variantsAccordion);
		this.fetchList();
	}

	private closeAccordion() {
		this.isAccordionOpen = false;
		this.variantsAccordion.remove();
		this.serviceRow.classList.remove("accordion-open");
	}
}
